import HistoryComponent from "../components/HistoryComponent";
import useHistory from "../hook/useHistory";
import useProduct from "../hook/useProduct";


const HistoryPage = ({

}) => {
    const history = useHistory();
    const footerMenu = useProduct();
    return <HistoryComponent {...history} {...footerMenu} />
}
export default HistoryPage;